import { ApiListResponse, TemplateDTO } from "@gymflow/types";
import { AxiosInstance } from "axios";

import { createSortParam } from "../createSortParam";
import { trimFields } from "./features/trimFiels";

export type EmailTemplateApiType = ReturnType<typeof emailTemplateApi>;

const emailTemplateApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const fieldsToTrim = ["templateName", "templateType", "subject", "body"];

  return {
    find({
      page = 0,
      limit = 10,
      extraParams = {},
      sort,
    }: {
      readonly extraParams?: {
        readonly [k: string]: any;
      };
      readonly page?: number;
      readonly limit?: number;
      readonly sort?: {
        readonly field: string;
        readonly desc?: boolean;
      };
    }) {
      const config = {
        params: {
          page,
          size: limit,
          ...extraParams,
        },
      } as any;
      if (sort) {
        config.params.sort = createSortParam(sort);
      }
      return axiosInstance.get<ApiListResponse<TemplateDTO>>(
        `${clubPrefix}template`,
        config,
      );
    },
    findById(id: number) {
      return axiosInstance.get<TemplateDTO>(`${clubPrefix}template/${id}`);
    },
    create(newResource: unknown) {
      return axiosInstance.post(
        `${clubPrefix}template`,
        trimFields(newResource, fieldsToTrim),
      );
    },
    update(id: number, patchedFields: { [k: string]: any }) {
      return axiosInstance.patch(
        `${clubPrefix}template/${id}`,
        trimFields(patchedFields, fieldsToTrim),
      );
    },
    delete(emailTemplateId: number) {
      return axiosInstance.delete(`${clubPrefix}template/${emailTemplateId}`);
    },
  };
};

export default emailTemplateApi;
